// src/widgets/calendarSchedule/ui/ArrowControls.tsx
import { FC } from 'react';
import { SlickNextIcon, SlickPrevIcon } from 'shared/ui/Icons/Icons';

import { IArrowControlsProps } from '../models/types';

import styles from './styles.module.scss';

export const ArrowControls: FC<IArrowControlsProps> = ({
  value,
  onChange,
  direction,
}) => {
  const handleClick = () => {
    const month = value.month();
    const newMonth = direction === 'prev' ? month - 1 : month + 1;
    const newYear =
      newMonth < 0
        ? value.year() - 1
        : newMonth > 11
          ? value.year() + 1
          : value.year();
    const now = value
      .clone()
      .year(newYear)
      .month((newMonth + 12) % 12);
    onChange(now);
  };

  return (
    <div className={styles['arrow']} onClick={handleClick}>
      {direction === 'prev' ? <SlickPrevIcon /> : <SlickNextIcon />}
    </div>
  );
};
